<template lang="html">
  <div
    class="logo"
  >
    <HoldingIcon
      v-if="site === 'holding'"
      class="logo__image"
    />
    <CapitalIcon
      v-else
      class="logo__image"
    />
  </div>
</template>

<script>
import anime from 'animejs'

import HoldingIcon from 'beisheim/assets/images/logos/beisheim-holding-logo-wortbildmarke.svg'
import CapitalIcon from 'beisheim/assets/images/logos/beisheim-capital-logo-wortbildmarke.svg'

export default {
  components: {
    HoldingIcon,
    CapitalIcon
  },
  props: {
    site: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    animation () {
      const timeline = anime.timeline()
      const duration = 2000

      timeline
        .add({
          targets: ['[data-logo-holding="violet"]'],
          strokeDashoffset: [anime.setDashoffset, 0],
          duration,
          easing: 'easeInOutQuad',
          offset: 0
        })
        .add({
          targets: ['[data-logo-holding="rose"]'],
          strokeDashoffset: [anime.setDashoffset, 0],
          duration,
          easing: 'easeInOutQuad',
          offset: 0
        })
        .add({
          targets: ['[data-logo-holding="mint"]'],
          strokeDashoffset: [anime.setDashoffset, 0],
          duration,
          easing: 'easeInOutQuad',
          offset: 0
        })
        .add({
          targets: ['[data-logo-holding="yellow"]'],
          strokeDashoffset: [anime.setDashoffset, 0],
          duration,
          easing: 'easeInOutQuad',
          offset: 0
        })
      return timeline
    }
  },
  mounted () {
    this.animation.play()
    this.$el.addEventListener('mouseover', this.mouseOver)
  },
  methods: {
    mouseOver () {
      this.animation.seek(0)
      this.animation.play()
    }
  }
}
</script>

<style lang="scss">
@import 'beisheim/scss/breakpoints';
.logo {
  display: block;
}

.logo__image {
  width: 100%;
  display: block;
}
</style>
